<ng-template #RaceInfoTemplate let-isHeader="isHeader">
    @if (!isResulted) {
        <div class="greyhound-race-info">
            <div>
                <div class="breadcrumb-back">
                    @if (isHeader) {
                        <button ds-button-icon variant="flat-reduced" kind="tertiary" size="large" (click)="goBack()">
                            <vn-icon name="theme-left" />
                        </button>
                    }
                    <div class="location-name" [ngClass]="{ 'sub-header-location-name': !isHeader }">
                        @if (!isHeader) {
                            <strong> {{ fixture.startDate | date: 'HH:mm' }} </strong>
                        }
                        <strong> {{ fixture.meeting.name | msTranslate }} </strong>
                    </div>
                    @if (!isHeader) {
                        <div class="startIn">
                            <ms-greyhound-timer [race]="fixture" [timeInSeconds]="countDownTimer" />
                        </div>
                    }
                </div>
                @if (!isMobile && isHeader) {
                    <div class="header-right">
                        <ng-container *ngTemplateOutlet="dsTabs" />
                    </div>
                }
                @if (!isHeader) {
                    <div class="greyhound-race-distance-info">
                        <div class="gh-race-info">
                            <ms-gh-race-info msTextAutoScroll class="race-name" [race]="fixture" [marketTitle]="marketTitle" />
                        </div>
                    </div>
                }
            </div>
        </div>
    }
</ng-template>
@if (!isMobile) {
    <ng-container *ngTemplateOutlet="RaceInfoTemplate; context: { isHeader: true }" />
}
<section class="horses-race-details greyhound-box" [ngClass]="{ 'resulted-greyhound-details': isResulted }">
    @if (isResulted) {
        <div>
            <ng-container *ngTemplateOutlet="greyhoundsResulted; context: { isHeader: false }" />
        </div>
    }
    <ng-container *ngTemplateOutlet="RaceInfoTemplate; context: { isHeader: false }" />
    <ng-template #greyhoundsResulted>
        <header class="greyhounds-main-header">
            @if (!isMobile) {
                <div class="greyhound-result-title">
                    @if (!isMobile) {
                        <div class="breadcrumb-back">
                            <button ds-button-icon variant="flat-reduced" kind="tertiary" size="medium" (click)="goBack()">
                                <vn-icon name="theme-left" />
                            </button>
                        </div>
                        <span class="location-name">
                            <strong>{{ fixture.meeting.name | msTranslate }}</strong>
                        </span>
                    }
                </div>
                <div class="header-right">
                    <ng-container *ngTemplateOutlet="dsTabs" />
                </div>
            }
            <div class="greyhound-race-resulted-header">
                <div class="resulted-time-status">
                    <div class="greyhound-time">
                        {{ fixture.startDate | date: 'HH:mm' }}
                        <span class="location-name">
                            <strong>{{ fixture.meeting.name | msTranslate }}</strong>
                        </span>
                    </div>
                    <div class="settled-result">
                        <div class="settled">
                            {{ sitecore.horseRacing.raceResulted.SettledResult }}
                        </div>
                    </div>
                    <ms-horses-race-badges [resulted]="isResulted" [rule4Expected]="fixture.addons.rule4Expected" />
                </div>
                <div class="resulted-win-info">
                    <ms-gh-race-info msTextAutoScroll class="race-name" [race]="fixture" [marketTitle]="marketTitle" />
                    <div class="greyhounds-longdate">
                        {{ fixture.startDate | date: 'd MMMM y' }}
                    </div>
                </div>
            </div>
        </header>
    </ng-template>
    @if (isResulted) {
        <ms-greyhounds-race-resulted [fixture]="fixture" [isGreyhounds]="true" [greyhoundTrapDogMapping]="greyhoundTrapDogMapping" />
    }
</section>
<div class="horses-race-details greyhound-box">
    @if (!fixture.isOptionBet && !isResulted) {
        @if (!isResulted) {
            <ms-greyhounds-race
                [fixture]="fixture"
                [isGreyhounds]="true"
                [trackingSource]="trackingSource"
                [isNextRaces]="false"
                [greyhoundTrapDogMapping]="greyhoundTrapDogMapping" />
        }
    }
    @if (fixture.isOptionBet && !isResulted) {
        <ms-greyhounds-derived-race
            [fixture]="fixture"
            [isGreyhounds]="true"
            [trackingSource]="trackingSource"
            [isNextRaces]="false"
            [greyhoundTrapDogMapping]="greyhoundTrapDogMapping" />
    }
</div>

@if (!fixture) {
    <ms-error [links]="false" [message]="sitecore.fixture.common.ErrorNoFixture" [severity]="'info'" />
}

<ng-template #dsTabs>
    @if (tabs.length) {
        <ds-tabs-group
            class="icon-alignment arrow-alignment"
            fullWidthTabs="false"
            size="small"
            variant="horizontal"
            scrollSpeed="fast"
            [scrollable]="true"
            [activeTab]="active.id.toString()"
            (activeTabChange)="selected($event)">
            @for (tab of tabs; track tab.id) {
                <ds-tab [name]="tab.id.toString()">
                    <ng-container *dsTabHeader>
                        <a [msLink]="tab.url" [vnSpeculativeLink]="tab.url ?? ''">
                            @if (tab.icon) {
                                <vn-icon class="race-resulted-icon" size="13" [name]="tab.icon" />
                            }
                            {{ tab.title }}
                        </a>
                    </ng-container>
                </ds-tab>
            }
        </ds-tabs-group>
    }
</ng-template>
